<template>
  <div
    class="page-home"
    style
  >
    <div class="flex-between">
      <div class="card card--visit">
        <div>
          <p class="card__title ">{{visit.amount}}</p>
          <p>客户今日访问量</p>
        </div>
        <div class="card__footer">
          <span class="label">当月访问量</span>
          <span>{{visit.sum}}</span>
        </div>
      </div>
      <div class="card card--amount">
        <div style="min-width:150px;">
          <p class="card__title ">{{performance.countByToday}}</p>
          <p>今日成交笔数</p>
        </div>
        <div>
          <p class="card__title ">{{performance.money}}</p>
          <p>今日成交金额</p>
        </div>
        <div class="card__footer">
          <span class="label">当月成交金额</span>
          <span>{{performance.totalMoney}}</span>
        </div>
      </div>
      <div class="card card--plan">
        <div>
          <p class="card__title ">{{plan.amount}}</p>
          <p>今日计划数量</p>
        </div>
        <div class="card__footer"></div>
      </div>
    </div>
    <div class="flex-between">
      <section class="trend trend--visit">
        <div>
          <p class="title">客户访问走势图<span
              class="subtitle"
              v-show="canViewService"
              @click="onViewClick('visit')"
            >查看今日到访 </span></p>
        </div>
        <div class="chart-container">
          <v-chart :options="visitTrend"></v-chart>
        </div>
      </section>
      <section class="trend trend--business">
        <div>
          <p class="title">业绩走势图 <span
              @click="onViewClick('performance')"
              class="subtitle"
              v-if="canViewPerformance"
            >查看今日业绩 </span></p>
        </div>
        <div class="chart-container">
          <v-chart :options="businessTrend"></v-chart>
        </div>
      </section>
      <section class="trend rate--plan">
        <div>
          <p class="title">计划完成率 <span
              @click="onViewClick('plan')"
              class="subtitle"
              v-if="canViewTodayPlan"
            >查看今日计划</span></p>
        </div>
        <div class="chart-container">
          <v-chart :options="rateTrend"></v-chart>
        </div>
      </section>
    </div>
    <div class="table-title">最新产品 <span
        class="table-subtitle"
        @click="onViewClick('latest')"
        v-show="canViewMoreLatest"
      >查看更多最新产品</span></div>
    <el-table
      :data="tableData"
      header-row-class-name="grey-header"
      border
    >
      <el-table-column
        v-for="col in tableLabel"
        :key="col.prop"
        :label="col.label"
        :prop="col.prop"
        min-width="300px"
      ></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="100"
      >
        <template slot-scope="scope">
          <span
            class="button--blue"
            @click="onDetailClick(scope.row)"
            v-show="canViewLatestProductDetail"
          >产品详情</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addNav, getFunctionList } from '@/mixins';

export default {
  name: 'HomePage',
  mixins: [addNav, getFunctionList],
  data() {
    const { workNo } = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      workNo,
      functionList: [],
      performance: {
        dateList: [],
        valueList: [],
        countByToday: 0,
        money: 0,
        totalMoney: 0,
      },
      visit: {
        dateList: [],
        valueList: [],
        amount: 0,
        sum: 0,
      },
      plan: {
        amount: 0,
        undo: 0,
        completed: 0,
      },
      tableData: [],
      tableLabel: [{
        label: '产品名称',
        prop: 'prdName',
      }, {
        label: '产品类型',
        prop: 'prdTypeRes',
      }, {
        label: '产品状态',
        prop: 'saleStatusRes',
      }, {
        label: '上架时间',
        prop: 'createTime',
      }],

    };
  },
  computed: {
    canViewLatestProductDetail() {
      return this.functionList.includes('336040758297202688');
    },
    canViewMoreLatest() {
      return this.functionList.includes('336040364020043776');
    },
    canViewPerformance() {
      return this.functionList.includes('336040063301029888');
    },
    canViewTodayPlan() {
      return this.functionList.includes('322222700680155136');
    },
    canViewService() {
      return this.functionList.includes('329526117392097280');
    },
    rateTrend() {
      return {
        color: ['#02BB6F', '#F95353', '#1E88FF'],
        series: [{
          label: {
            normal: {
              formatter: '{c}',
              position: 'inside',
            },
          },
          type: 'pie',
          radius: '65%',
          data: [{
            name: '已完成',
            value: this.plan.completed,
          }, {
            name: '未执行',
            value: this.plan.undo,
          }],
        }, {
          labelLine: {
            normal: {
              length: 7,
              length2: 3,
            },
          },
          type: 'pie',
          radius: '65%',
          data: [{
            name: '已完成',
            value: this.plan.completed,
          }, {
            name: '未执行',
            value: this.plan.undo,
          }],
        }],
      };
    },
    visitTrend() {
      return {
        tooltip: {
          trigger: 'axis',
          formatter: '日期:{b0}<br>人数:{c0}',
        },
        xAxis: {
          axisTick: false,
          type: 'category',
          data: this.visit.dateList,
        },
        yAxis: {
          axisTick: false,
          type: 'value',
          minInterval: 1,
        },
        series: [{
          data: this.visit.valueList,
          type: 'line',
          smooth: true,
          showSymbol: false,
          itemStyle: {
            normal: {
              lineStyle: {
                color: '#3981F1',
              },
            },
          },
        }],
      };
    },
    businessTrend() {
      return {
        grid: {
          x: 50,
        },
        tooltip: {
          trigger: 'axis',
          formatter: '日期:{b0}<br>业绩(万):{c0}',
        },
        xAxis: {
          axisTick: false,
          type: 'category',
          boundaryGap: true,
          data: this.performance?.dateList,
        },
        yAxis: {
          name: '业绩(万)',
          axisTick: false,
          type: 'value',
          minInterval: 10000,
          axisLabel: {
            formatter(a) {
              return (a / 10000).toFixed(1);
            },
          },
        },
        series: [{
          data: this.performance?.valueList,
          type: 'line',
          smooth: true,
          showSymbol: false,
          itemStyle: {
            normal: {
              lineStyle: {
                color: '#FAA61C',
              },
            },
          },
        }],
      };
    },
  },
  mounted() {
    // this.listLatestProduct();
    // Promise.all([
    //   this.listPerformance(),
    //   this.listVisitor(),
    //   this.getTodayPlan()])
    //   .then(([performance, visit, plan]) => {
    //     this.transformData('performance', performance);
    //     this.transformData('visit', visit);
    //     if (plan.errorCode === this.$CODE.success) {
    //       this.plan.amount = plan.data.amount;
    //       this.plan.completed = plan.data.mapList?.completed;
    //       this.plan.undo = plan.data.mapList?.undo;
    //     }
    //   });
  },
  methods: {
    onDetailClick(detail) {
      const routeMap = {
        1: '/financiaPrdDetail',
        2: '/cds-detail',
      };
      this.addNav({
        path: routeMap[detail.prdType],
        query: {
          prdCode: detail.prdCode,
          prdName: detail.prdName,
        },
        name: '产品详情',
      });
    },
    listLatestProduct() {
      return this.$_post(this.$API.listIndexProduct).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.tableData = res.data.list;
        }
      });
    },
    getTodayPlan() {
      const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
      return this.$_post(this.$API.todayPlan, {
        data: {
          workNo: this.workNo,
          ownerUserId: userId,
        },
      });
    },
    transformData(name, res) {
      this[name] = {
        ...res.data,
      };
      this[name].dateList = res.data.list.map(item => item.date);
      this[name].valueList = res.data.list.map(item => item.achievement);
    },
    listPerformance() {
      return this.$_post(this.$API.getTrend, {
        data: {
          workNo: this.workNo,
        },
      });
    },
    listVisitor() {
      return this.$_post(this.$API.visitNumber, {
        data: {
          workNo: this.workNo,
        },
      });
    },
    onViewClick(where) {
      const whereMap = {
        performance: {
          path: '/today-performance',
          name: '今日业绩',
        },
        plan: {
          path: '/call-plan',
          name: '电访计划',
        },
        visit: {
          path: '/fieldServRecordQuery',
          name: '现场服务记录',
        },
        latest: {
          path: '/latest-product',
          name: '最新产品',
        },
      };
      this.addNav({
        ...whereMap[where],
        query: {
          today: 'yes',
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-home {
  height: 100%;
  overflow: auto;
}
.flex-between {
  color: #fff;
  font-size: 14px;

  & > * + * {
    margin-left: 18px;
  }

  .card {
    color: #fff;
    display: flex;
    height: 130px;
    box-sizing: border-box;
    padding: 12px 20px;
    border-radius: 4px;
    position: relative;
    background-position: right 12px top 15px;
    background-size: 50px;
    background-repeat: no-repeat;

    .card__title {
      font-size: 32px;
    }
  }

  .card__footer {
    background-color: rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    position: absolute;
    left: 0;
    bottom: 0;

    & .label {
      margin-right: 20px;
    }
  }

  .card--visit {
    background-color: #1e88ff;
    background-image: url("../assets/images/customer.png");
    width: 280px;
  }
  .card--amount {
    background-color: #faa61c;
    background-image: url("../assets/images/amount.png");
    flex: 1;
  }
  .card--plan {
    background-color: #02bb6f;
    width: 280px;
    background-image: url("../assets/images/plan.png");
  }

  .echarts {
    width: 100%;
    height: 100%;
  }
  .trend--visit,
  .trend--business {
    flex: 1;
  }
  .chart-container {
    height: 260px;
    background: #f5f7fa;
    border-radius: 4px;
  }
  .rate--plan {
    width: 280px;
  }
  .title {
    padding-top: 24px;
    margin-bottom: 14px;
    font-size: 16px;
    color: #303133;
  }
  .subtitle {
    color: #1e88ff;
    font-size: 14px;
    float: right;
    cursor: pointer;
    padding: 0;
  }
}
.table-title {
  padding-top: 24px;
  padding-bottom: 14px;
  font-size: 16px;
  color: #303133;
  .table-subtitle {
    cursor: pointer;
    float: right;
    font-size: 14px;
    color: #1e88ff;
  }
}
</style>
<style lang="scss">
.grey-header {
  th {
    background: #f5f7fa;
  }
}
</style>
